import React, { useEffect, useState, useMemo } from "react";
import api, { BASE_URL } from "../../Utils/api";
import { Card, Spinner, Row, Col } from "react-bootstrap";
import {
  Chart as ChartJS,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import {
  KpisEstatisticas,
  DistribuicaoPorTipoDocumento,
  DistribuicaoPorResponsavel,
  MaioresArquivosTop15,
  ArquivosPorEntidade,
  TokensAtivos,
  formatarTamanho,
} from "../Generals/Estatisticas";

ChartJS.register(ArcElement, Title, Tooltip, Legend);


function EstatisticasGodMode() {
  const token = localStorage.getItem("authToken");
  const [arquivos, setArquivos] = useState([]);
  const [porTipoDocumento, setPorTipoDocumento] = useState([]);
  const [porResponsavel, setPorResponsavel] = useState([]);
  const [kpiEntidades, setKpiEntidades] = useState(0);
  const [kpiTotalArquivos, setKpiTotalArquivos] = useState(0);
  const [kpiDocumentos, setKpiDocumentos] = useState(0);
  const [kpiTamanhoTotal, setKpiTamanhoTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);

    const baseKpi = "";
    const headers = { Authorization: `Bearer ${token}` };

    Promise.all([
      api.get(`${BASE_URL}/api/estatisticas/ListarUploads${baseKpi}`, { headers }),
      api.get(`${BASE_URL}/api/estatisticas/ContagemPorTipoDocumento${baseKpi}`, { headers }),
      api.get(`${BASE_URL}/api/estatisticas/ContagemPorResponsavel${baseKpi}`, { headers }),
      api.get(`${BASE_URL}/api/estatisticas/KpiEntidades${baseKpi}`, { headers }),
      api.get(`${BASE_URL}/api/estatisticas/KpiTotalArquivos${baseKpi}`, { headers }),
      api.get(`${BASE_URL}/api/estatisticas/KpiDocumentos${baseKpi}`, { headers }),
      api.get(`${BASE_URL}/api/estatisticas/KpiTamanhoTotal${baseKpi}`, { headers }),
    ])
      .then(([rArquivos, rTipoDoc, rResponsavel, rEnt, rTotal, rDoc, rTamanho]) => {
        const list = rArquivos.data?.data ?? [];
        setArquivos(Array.isArray(list) ? list : []);
        setPorTipoDocumento(Array.isArray(rTipoDoc.data?.data) ? rTipoDoc.data.data : []);
        setPorResponsavel(Array.isArray(rResponsavel.data?.data) ? rResponsavel.data.data : []);
        setKpiEntidades(Number(rEnt.data?.data) ?? 0);
        setKpiTotalArquivos(Number(rTotal.data?.data) ?? 0);
        setKpiDocumentos(Number(rDoc.data?.data) ?? 0);
        setKpiTamanhoTotal(Number(rTamanho.data?.data) ?? 0);
      })
      .catch((err) => {
        console.error("Erro ao carregar estatísticas God Mode:", err);
        setError(err.response?.data?.message || "Erro ao carregar estatísticas.");
        setArquivos([]);
        setPorTipoDocumento([]);
        setPorResponsavel([]);
        setKpiEntidades(0);
        setKpiTotalArquivos(0);
        setKpiDocumentos(0);
        setKpiTamanhoTotal(0);
      })
      .finally(() => setLoading(false));
  }, [token]);

  const porEntidade = useMemo(() => {
    const mapa = new Map();
    for (const a of arquivos) {
      const chave = a.id_entidade ?? 0;
      if (!mapa.has(chave)) {
        mapa.set(chave, {
          id_entidade: a.id_entidade,
          nome: a.nome_entidade || `Entidade #${a.id_entidade}`,
          arquivos: [],
        });
      }
      mapa.get(chave).arquivos.push(a);
    }
    return Array.from(mapa.values()).sort((a, b) => (a.nome ?? "").localeCompare(b.nome ?? ""));
  }, [arquivos]);

  const topPorTamanho = useMemo(
    () =>
      [...arquivos]
        .filter((a) => a.tamanho != null && a.tamanho > 0)
        .sort((a, b) => (b.tamanho || 0) - (a.tamanho || 0))
        .slice(0, 15),
    [arquivos]
  );

  const kpis = [
    { label: "Entidades", valor: kpiEntidades, cor: "#7c3aed" },
    { label: "Total de arquivos", valor: kpiTotalArquivos, cor: "#2563eb" },
    { label: "Documentos", valor: kpiDocumentos, cor: "#0891b2" },
    { label: "Tamanho total", valor: formatarTamanho(kpiTamanhoTotal), cor: "#b45309" },
  ];

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <div>

      {error && (
        <Card className="mb-3 border-danger">
          <Card.Body className="text-danger">{error}</Card.Body>
        </Card>
      )}

      <KpisEstatisticas kpis={kpis} />

      {(porTipoDocumento.length > 0 || porResponsavel.length > 0) && (
        <Row className="g-3 mb-4">
          {porTipoDocumento.length > 0 && (
            <Col xs={12} md={6}>
              <DistribuicaoPorTipoDocumento porTipoDocumento={porTipoDocumento} />
            </Col>
          )}
          {porResponsavel.length > 0 && (
            <Col xs={12} md={6}>
              <DistribuicaoPorResponsavel porResponsavel={porResponsavel} />
            </Col>
          )}
        </Row>
      )}

      <MaioresArquivosTop15 topPorTamanho={topPorTamanho} isGlobal />

      <div className="mb-4">
        <TokensAtivos />
      </div>

      <ArquivosPorEntidade porEntidade={porEntidade} />
    </div>
  );
}

export default EstatisticasGodMode;
